module.exports = __webpack_public_path__ + "img/VisitorManagementBG.9dcb3cb3.jpg";